<template>
  <div class="firewall-container">
    <div>
      <el-tabs v-model="tabActive" @tab-click="setTabActive">
        <el-tab-pane label="Transaction Firewall" name="transaction">
          <TransactionFirewall/>
        </el-tab-pane>
        <el-tab-pane label="Beneficiary Monitor" name="beneficiary">
          <BeneFiciaryFirewall/>
        </el-tab-pane>
        <el-tab-pane label="Settings" name="settings">
          <SettingFirewall/>
        </el-tab-pane>

      </el-tabs>
    </div>
  </div>
</template>
        
<script>
import TransactionFirewall from './transaction/index.vue'
import BeneFiciaryFirewall from './beneficiary/index.vue'
import SettingFirewall from './settings/firewall-autocase.vue'
export default {
 components:{
  TransactionFirewall,
  BeneFiciaryFirewall,
  SettingFirewall
 },
 data(){
  return {
    tabActive: this.$route.query.tab || "transaction",
  }
 },
 methods:{
  setTabActive(tab){
      this.$router.push('?tab='+tab.name)
    },
 }
};
</script>

<style>
</style>